import { BrowserRouter, Route, Routes } from "react-router-dom";
import Reservations from "./pages/Reservations";
import Dashboard from "./pages/Dashboard";
import Navbar from "./components/Navbar";
import Calendar from "./pages/Calendar";
import Conversations from "./pages/Conversations";
import Messages from "./pages/Messages";
import Cleaners from "./pages/Cleaners";
import LoginPage from "./pages/Login";
import ProtectedRoute from "./ProtectedRoute"; // Import the protected route
import { useState } from "react";

function App() {

  const serverURL = "http://hostaway.stevenbrekalo.com";


  const [conversationID, setConversationID] = useState('');

  return (
    <BrowserRouter>
      <Navbar conversationID={conversationID}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          
          {/* Protected Routes */}
          <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/reservations" element={<ProtectedRoute><Reservations /></ProtectedRoute>} />
          <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
          <Route path="/conversations" element={<ProtectedRoute><Conversations /></ProtectedRoute>} />
          <Route path="/conversations/:conversationID" element={<ProtectedRoute><Messages serverURL={serverURL} setConversationID={setConversationID}/></ProtectedRoute>} />
          <Route path="/cleaners" element={<ProtectedRoute><Cleaners /></ProtectedRoute>} />
        </Routes>
      </Navbar>
    </BrowserRouter>
  );
}

export default App;
